import React, { useEffect } from "react";
import "../../../../../Assets/Styles/UserGuide.scss";

const NavBookmarksGuide = (props) => {
  useEffect(() => {
    if (window.innerWidth <= 450) {
      window.scrollTo(0, 0);
    }
  }, []);
  const toggleNextGuide = () => {
    props.ToggleNextDialog();
  };

  const togglePreviousGuide = () => {
    props.TogglePreviousDialog();
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  return (
    <div className="guide-dialog nav-bookmarks-guide">
      <i className="feather-x" onClick={() => props.CloseGuide()}></i>
      <p className="dialog-text">
        {translateText("walkthrough_nav_bookmarks")}
      </p>
      <section className="dialog-footer">
        <div className="steps-navs back" onClick={() => togglePreviousGuide()}>
          <i className="feather-arrow-left"></i>
          <p>{translateText("back")}</p>
        </div>
        <div className="indicators">
          <>
            {props.HasAdditionalStep ? (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(i)}
                    className={
                      i === 5 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i)}
                  ></span>
                ))}
              </>
            ) : (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(Item)}
                    className={
                      i === 4 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i)}
                  ></span>
                ))}
              </>
            )}
          </>
        </div>
        <div className="steps-navs next" onClick={() => toggleNextGuide()}>
          <p>{translateText("next")}</p>
          <i className="feather-arrow-right"></i>
        </div>
      </section>
    </div>
  );
};

export default NavBookmarksGuide;
